var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronBreadcrumbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8107 18.7753C10.44 19.2944 9.7214 19.3468 9.28671 18.8867L9.19668 18.7915C8.8466 18.4209 8.80092 17.8367 9.08869 17.4103L13.5408 11.967L9.08877 6.59125C8.801 6.16482 8.84667 5.58066 9.19676 5.2101L9.2868 5.1148C9.72148 4.65468 10.44 4.70724 10.8108 5.22628L15.8951 11.3204C16.1683 11.7029 16.1683 12.2311 15.8951 12.6135L10.8107 18.7753Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBreadcrumbIcon);
export default __webpack_public_path__ + "static/media/chevron_breadcrumb_icon.6d9337e64fa069113d90fbd5ae45e950.svg";
export { ForwardRef as ReactComponent };